import React from "react";
import styled from "styled-components";
import theme from "../../theme";
import Search from "../../image/search.svg";

export const CommonInput = (props) => {
  const {
    placeHolder,
    inputValue,
    setInputValue,
    type,
    searchImage,
    styleWidth,
    addressModal,
    onKeyPress,
    style,
  } = props;

  const white = theme.colors.white;

  const handleChange = (e) => {
    if (type === "phone") {
      const onlyNumber = e.target.value.replace(/[^0-9]/g, "");
      setInputValue(onlyNumber);
    } else {
      setInputValue(e.target.value);
    }
  };

  const ImageBoxJsx = (
    <ImageBox>
      <img src={Search} alt="" />
    </ImageBox>
  );

  return (
    <Container style={style && style} backColor={white} styleWidth={styleWidth}>
      {searchImage ? ImageBoxJsx : ""}
      <CustomInput
        placeholder={placeHolder}
        onChange={!onKeyPress ? (e) => handleChange(e) : null}
        onClick={addressModal ? (e) => addressModal(e) : null}
        onKeyPress={onKeyPress ? (e) => onKeyPress(e) : null}
        defaultValue={inputValue || ""}
      />
    </Container>
  );
};

const Container = styled.div`
  width: ${(props) => (props.styleWidth ? props.styleWidth : "20.5rem")};
  height: 3rem;
  border-radius: 4px;
  background-color: ${(props) => props.backColor};
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CustomInput = styled.input`
  width: 100%;
  line-height: 2.5rem;
  border: none;
  font-family: "SpoqaHanSansNeoRegular";
  font-weight: 400;
  font-size: 14px;

  &:focus {
    outline: none;
  }

  ::placeholder {
    color: #b6b3b3;
  }
`;

const ImageBox = styled.div`
  width: 0.915rem;
  height: 0.915rem;
  display: flex;
  margin-right: 9px;
`;
